<script setup>
import { Head } from '@inertiajs/vue3';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import { useRoute } from '@js/utils/route';

const { status } = defineProps({
    status: {
        type: Number,
        required: true,
    },
});

const { route } = useRoute();
</script>

<template>
    <Head>
        <title v-if="status === 403">Erreur 403</title>
        <title v-else-if="status === 404">Erreur 404</title>
        <title v-else-if="status === 500">Erreur 500</title>
        <title v-else-if="status === 503">Erreur 503</title>
        <title v-else>Erreur</title>
    </Head>

    <div
        class="relative flex min-h-screen min-w-screen items-center overflow-hidden bg-blue-100 p-5 lg:p-20"
    >
        <div
            class="relative min-h-full min-w-full flex-1 items-center rounded-3xl bg-white p-10 text-left text-gray-800 shadow-xl md:flex lg:p-20"
        >
            <div class="w-full md:w-1/2">
                <div class="mb-10 lg:mb-20">
                    <img src="/images/logo/logo.svg" class="w-1/2" alt="..." />
                </div>

                <div class="mb-10 font-light text-gray-600 md:mb-20">
                    <h1
                        class="mb-10 text-3xl font-black text-indigo-600 uppercase lg:text-5xl"
                    >
                        <template v-if="status === 403"> Erreur 403 </template>
                        <template v-else-if="status === 404">
                            Erreur 404
                        </template>
                        <template v-else-if="status === 500">
                            Erreur 500
                        </template>
                        <template v-else-if="status === 503">
                            Erreur 503
                        </template>
                        <template> Erreur </template>
                    </h1>

                    <p v-if="status === 403">
                        Vous n'avez pas les droits pour accéder à cette page.
                    </p>
                    <p v-else-if="status === 404">
                        La page que vous cherchez n'existe pas.
                    </p>
                    <p v-else-if="status === 500">
                        Une erreur serveur est survenue.
                    </p>
                    <p v-else-if="status === 503">
                        Le serveur est indisponible pour cause de maintenance.
                    </p>
                    <p v-else>Une erreur est survenue.</p>
                </div>

                <div v-if="status !== 503" class="mb-20 md:mb-0">
                    <ActionButton :href="route('front.index')">
                        Retour à l'accueil
                    </ActionButton>
                </div>
            </div>

            <div class="w-full text-center md:w-1/2">
                <img src="/images/illustrations/lost.svg" alt="Perdu" />
            </div>
        </div>

        <div
            class="pointer-events-none absolute -top-64 right-20 h-96 w-64 -rotate-45 transform rounded-full bg-blue-200/30 md:-top-96 md:right-32 md:h-full md:w-96"
        ></div>

        <div
            class="pointer-events-none absolute right-64 -bottom-96 h-full w-96 -rotate-45 transform rounded-full bg-indigo-950/20"
        ></div>
    </div>
</template>
